import React from 'react';

import StepWithOptions from 'containers/Quiz/StepWithOptions';

import { LOVERS_TRACKING, QUIZ_ROUTE } from '..';

const CHOICES = [
  {
    id: 1,
    text: 'components.LoversQuiz.Steps.Timing.choices.1',
    tracking: 'relax-couch',
  },
  {
    id: 2,
    text: 'components.LoversQuiz.Steps.Timing.choices.2',
    tracking: 'wake-up',
  },
  {
    id: 3,
    text: 'components.LoversQuiz.Steps.Timing.choices.3',
    tracking: 'spicy-break',
  },
  {
    id: 4,
    text: 'components.LoversQuiz.Steps.Timing.choices.4',
    tracking: 'night-bed',
  },
];

const section = {
  sectionName: 'scenario',
  choices: CHOICES,
};

const Scenario = () => {
  return (
    <StepWithOptions
      section={section}
      question={{ id: 'components.LoversQuiz.Steps.Timing.question' }}
      tracking={{ name: LOVERS_TRACKING, url: `${QUIZ_ROUTE}/scenario` }}
    />
  );
};

export default Scenario;
